/**
 * Settings page component
 */

import React from 'react';
import { Card, CardContent, CardHeader } from '../components/ui/card';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { useApiUrl } from '../config';

export const Settings: React.FC = () => {
  const apiUrl = useApiUrl();
  
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-h1 font-semibold text-gray-900">Settings</h1>
        <p className="text-gray-500 mt-2">Manage your platform settings and preferences</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <h3 className="text-lg font-medium text-gray-900">API Configuration</h3>
          </CardHeader>
          <CardContent>
            <div className="access-form">
              <div className="access-form-item">
                <label className="access-label" htmlFor="apiBaseUrl">
                  API Base URL
                </label>
                <input
                  id="apiBaseUrl"
                  type="text"
                  defaultValue={apiUrl || 'http://localhost:8080'}
                  className="access-input"
                />
                <p className="access-form-helper">Backend API endpoint</p>
              </div>
              <div className="access-form-item">
                <label className="access-label" htmlFor="apiTimeout">
                  API Timeout (ms)
                </label>
                <input
                  id="apiTimeout"
                  type="number"
                  defaultValue="10000"
                  className="access-input"
                />
                <p className="access-form-helper">Request timeout in milliseconds</p>
              </div>
              <button className="access-btn access-secondary">Test Connection</button>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <h3 className="text-lg font-medium text-gray-900">Appearance</h3>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Theme
              </label>
              <select className="access-input">
                <option value="light">Light</option>
                <option value="dark">Dark</option>
                <option value="system">System</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Primary Color
              </label>
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary rounded border-2 border-gray-300"></div>
                <Input defaultValue="#E53E3E" className="flex-1" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};